import { render } from "./PromotionsDialog.vue?vue&type=template&id=557fb60e&scoped=true"
import script from "./PromotionsDialog.vue?vue&type=script&lang=js"
export * from "./PromotionsDialog.vue?vue&type=script&lang=js"

import "./PromotionsDialog.vue?vue&type=style&index=0&id=557fb60e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557fb60e"]])

export default __exports__